"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M17.329 24.019a1.5 1.5 0 0 0 1.342 0L30 18.354V22.5c0 3.314-5.372 7.5-12 7.5-3.589 0-7.8-2.348-10-4v-6.485z" }),
  React.createElement("path", { d: "M34.658 11.88L18.671 3.887a1.5 1.5 0 0 0-1.342 0L1.347 11.878a.753.753 0 0 0-.005 1.344l2.752 1.4-.081 13.25a16 16 0 0 1-.58 4.174L3 33.61c-.2.932.215 1.807 1.167 1.807h1.646c.945 0 1.374-.865 1.188-1.791l-.424-1.537A16 16 0 0 1 6 27.834V16l10.327-4A1.888 1.888 0 0 1 18 11.222c.991 0 1.794.528 1.794 1.178s-.8 1.178-1.794 1.178c-.051 0-.094-.016-.144-.019l-9.3 3.62 8.771 4.041a1.5 1.5 0 0 0 1.337 0l15.99-8a.75.75 0 0 0 .004-1.34z" })
);

